import Modal from 'react-modal';
import { useMedia } from 'react-use';

import { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import ExersizeSvg from '../../../aassets/ic/exersize.svg';
import LogoutSvg from '../../../aassets/ic/logout.svg';
import MyDataSvg from '../../../aassets/ic/mydata.svg';
import { ReactComponent as Logo } from '../../../aassets/img/adaptor-logo.svg';
import avatar from '../../../aassets/img/avatar.png';
import { ReactPressVars } from '../../../types';
import Burger from '../Burger/Burger';
import s from './Menu.module.scss';

interface Props {
	root: HTMLElement;
	wpdata: ReactPressVars;
}
const Menu = ({ root, wpdata }: Props) => {
	const isMobile = useMedia('(max-width: 1790px)');
	const [isOpen, setIsOpen] = useState<boolean>(false);
	const handleNavClick = () => {
		isMobile && setIsOpen(false);
	};

	let username = '';

	if (wpdata.user.ID !== 0 && wpdata.usermeta !== false) {
		if (wpdata.usermeta?.first_name[0]) {
			username += wpdata.usermeta.first_name[0];
		} else if (wpdata.usermeta?.nickname[0]) {
			username += wpdata.usermeta.nickname[0];
		}
		if (wpdata.usermeta?.last_name) {
			username += ' ' + wpdata.usermeta.last_name;
		}
	} else {
		username = 'אורח';
	}
	const navigation = (
		<>
			<nav className={s.nav}>
				<Link to="/" className={s.logo}>
					<Logo />
				</Link>
				<a href="/my-account/" className={s.userData}>
					<img src={avatar} alt="תמונת משתתמש" />
					<div className={s.nameWrap}>
						<div>ברוך שובך,</div>
						<div className={s.name}>{username}</div>
					</div>
				</a>
				<NavLink
					to="/exersizes"
					className={({ isActive }) =>
						isActive ? s.link_active : s.link
					}
					onClick={handleNavClick}>
					<img src={ExersizeSvg} alt="" />
					<span>יחידות תרגול</span>
					<div className={s.brdr} />
				</NavLink>
				<NavLink
					to="/mydata"
					className={({ isActive }) =>
						isActive ? s.link_active : s.link
					}
					onClick={handleNavClick}>
					<img src={MyDataSvg} alt="" />
					<span>הנתונים שלי</span>
					<div className={s.brdr} />
				</NavLink>
			</nav>
			<div className={s.btns}>
				{/* <button className={s.btn}>דף נוסחאות</button>
                    <button className={s.btn_ic}>
                        הדרכה
                        <img src={HatSvg} alt="" />
                    </button> */}
				<a href="/" className={s.btn_logout}>
					<img src={LogoutSvg} alt="" />
					יציאה מהמערכת
				</a>
			</div>
		</>
	);

	return isMobile ? (
		<>
			<Burger onClick={() => setIsOpen(!isOpen)} />
			<Modal
				isOpen={isOpen}
				onRequestClose={() => setIsOpen(false)}
				contentLabel="תפריט"
				closeTimeoutMS={300}
				className={{
					base: s['m__content'],
					afterOpen: s['m__content--after-open'],
					beforeClose: s['m__content--before-close'],
				}}
				overlayClassName={{
					base: s['m__overlay'],
					afterOpen: s['m__overlay--after-open'],
					beforeClose: s['m__overlay--before-close'],
				}}
				appElement={root}>
				{navigation}
			</Modal>
		</>
	) : (
		<div className={s.w__content}>{navigation}</div>
	);
};
export default Menu;
